import React from 'react';
/* Utils */
import { getStaticImageUrl } from 'client/utils/image-helpers';

export function CaramelLogo() {
  return (
    <div>
      <span
        style={{
          fontSize: '0.75rem',
        }}
      >
        Powered by&nbsp;
      </span>
      <img src={getStaticImageUrl('/img/car-buying/caramel/caramel-logo.svg')} alt="caramel logo" width={57} />
    </div>
  );
}
